<template>
<!--  :key="$route.fullPath"  -->
  <router-view :key="$route.path"></router-view>
</template>

<script>


import { getLoggedClient } from '@/app/views/auth/shared/services';
import { CLIENT_API_CREDENTIALS } from '@/config';

export default {
  name: 'App',
  data() {
    return {
      user: null
    }
  },
  created() {

    if (localStorage.getItem('token')
      && (localStorage.getItem('user_email') !== CLIENT_API_CREDENTIALS.email)
      && (localStorage.getItem('user_name') !== CLIENT_API_CREDENTIALS.name)
    ) {

      getLoggedClient().then(response => {

        if (response.status === 'success') {
          this.user = response.data;

          if ( this.user.banned ) {
            localStorage.removeItem('token');
          }

        }
        else {
          localStorage.removeItem('token');
          this.$router.push('/login').catch((err)=> { console.log(err);
            // throw new Error(`Problem handling something: ${err}.`)
          });
        }

      }).catch(error => {
        localStorage.removeItem('token');
        this.$router.push('/login').catch((err)=> { console.log(err);
            // throw new Error(`Problem handling something: ${err}.`)
        });
      });

      // console.error('CLIENT WEB *******');

    } else {

      // console.warn('CLIENT APP ******');
    }

  }
}
</script>

<style lang="scss">

  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';

  // Import Main styles for this application
  @import '@/assets/scss/style';

</style>
